<template>
  <div class="message_box">
    <p :class="talkerClass">{{displayTalker}}</p>
    <div>
      <p><span class="bold_label">{{displayTalkerName}}</span>{{saidAt}}</p>
      <p>{{message.content}}</p>
    </div>
  </div>
</template>

<script>
  import moment from "moment";

  export default {
    name: "MessageBox",

    props: {
      talkerType: {
        type: String,
        required: true
      },
      message: {
        type: Object,
        required: true
      },
      names: {
        type: Object,
        required: true
      },
    },

    computed: {
      saidAt() {
        return (this.message && this.message.createdAt)
          ? moment.unix(this.message.createdAt.seconds).format('M月DD日')
          : null;
      },
      displayTalker() {
        return (this.talkerType === this.message.talker) ? '自分' : '相手';
      },
      talkerClass() {
        return (this.message.talker === 'client') ? 'client-rectangle_button' : 'operator-rectangle_button';
      },
      displayTalkerName() {
        return (this.message.talker === 'client') ? this.names.client: this.names.operator;
      }
    }
  }
</script>

<style lang="scss" scoped>
  .message_box {
    display: flex;
    align-items: flex-start;
    > div > p {
      white-space: pre-line;

      > span {
        margin-right: 2rem;
      }
    }
    > .client-rectangle_button, .operator-rectangle_button {
      margin-right: 2rem;
    }
  }
</style>
